import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import ExpirationText from './components/expirationText'
import { selectProduct } from '../../../../flux/selectors/product'
import LoadingSkeleton from '../../Generics/LoadingSkeleton'

const StyledHeader = styled.div(({ theme: { colors } }) => ({
  borderBottom: `1px solid ${colors.light_grey}`,
  display: 'flex',
  flexDirection: 'row-reverse',
  flex: '1 1 auto',
}))

const StyledExpiration = styled.div(() => ({
  flex: '0 0 auto',
  alignSelf: 'flex-end',
  minWidth: 0,
  padding: '5px 15px',
}))

const ProductHeader = ({
  productId,
}) => {
  const product = useSelector(selectProduct(productId))

  if (!productId || !product) {
    return (
      <StyledHeader>
        <StyledExpiration><LoadingSkeleton width="50px" height="25px" /></StyledExpiration>
      </StyledHeader>
    )
  }

  const {
    settings: {
      expires_at: expiration,
    },
  } = product

  return expiration ? (
    <StyledHeader>
      <StyledExpiration>
        <ExpirationText>{expiration}</ExpirationText>
      </StyledExpiration>
    </StyledHeader>
  ) : null
}

ProductHeader.propTypes = {
  productId: PropTypes.string,
}

ProductHeader.defaultProps = {
  productId: undefined,
}

export default ProductHeader
